<template>
  <div class="" style="width: 100%;">
         <v-row>
      <v-col>
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-row align-start'>
          <v-btn text class="mx-2 mt-1" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>New {{this.singular}}</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            class="ml-2 mt-1"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
              label="First Name *"
              outlined
              v-model="data.firstName"
          />
          <v-text-field
              label="Last Name"
              outlined
              v-model="data.lastName"
          />
          <v-text-field
              label="Address"
              outlined
              v-model="data.address"
          />
          <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="data.dateOfBirth"
                  label="Date of Birth"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
              />
            </template>
            <v-date-picker
                v-model="data.dateOfBirth"
            />
          </v-menu>
          <v-select
              item-text="name"
              item-value="id"
              :items="userTypes"
              label="User Type *"
              outlined
              v-model="data.userTypeId"
          />
          <v-autocomplete
              :items="(this.getUser && (this.getUser.userTypeId===1 || this.getUser.userTypeId===2))?this.branches:this.getAllowedBranches"
              item-text="name"
              item-value="id"
              v-model="data.metadata.branchData.main"
              label="Main Branch *"
              outlined
              clearable
              @change="updateRemBranches"
          />
          <v-autocomplete
              :items="remBranches"
              item-text="name"
              item-value="id"
              v-model="data.metadata.branchData.allowed"
              label="Allowed Branches *"
              outlined
              chips
              deletable-chips
              multiple
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              label="Phone"
              outlined
              v-model="data.phone"
          />
          <v-text-field
              label="Email"
              outlined
              v-model="data.email"
          />
          <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="data.hireDate"
                  label="Hire Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
              />
            </template>
            <v-date-picker
                v-model="data.hireDate"
            />
          </v-menu>
          <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="data.fireDate"
                  label="Fire Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
              />
            </template>
            <v-date-picker
                v-model="data.fireDate"
            />
          </v-menu>
          <v-text-field
              label="Password *"
              outlined
              v-model="data.password"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="create" :disabled="!this.data.firstName || !this.data.password || !this.data.userTypeId || !this.data.metadata.branchData.main || !this.data.metadata.branchData.allowed.length>0">Create</v-btn>
        </v-col>
      </v-row>
    </v-container>
      </v-col>
     </v-row>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        loader: false,

        branches: [],
        remBranches: [],
        lastBranch: null,

        max25chars: v => v.length <= 25 || 'Input too long!',
        data: {
          metadata: {
            branchData: {
              allowed: []
            }
          }
        },
        userTypes: [],
        singular: "User",
        singularLower: "user",
        plural: "Users",
        pluralLower: "users"
      }
    },
    async mounted(){
      try{
        let uts = await axios.get(`${this.getEndpoint}/api/usertypes`);
        this.userTypes = uts.data.data;

        let branches = await axios.get(`${this.getEndpoint}/api/locations/branches`);
        this.branches = branches.data.data;

        this.updateRemBranches();
      }
      finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getUser', 'getEndpoint', "getAllowedBranches"])
    },
    methods: {
      async create(){
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.data)

        this.$snack(`${this.singular} Created 🎉`, "success");

        await this.$router.push({ path: `/${this.pluralLower}/view/${res.data.data.id}`})
      },
      updateRemBranches(){
        if(this.data.metadata.branchData.main===null){
          this.remBranches = (this.getUser && (this.getUser.userTypeId===1 || this.getUser.userTypeId===2))?this.branches:this.getAllowedBranches;
        }
        else{
          let arr = [];

          for(let branch of ((this.getUser && (this.getUser.userTypeId===1 || this.getUser.userTypeId===2))?this.branches:this.getAllowedBranches)){
            let obj = {
              name: branch.name,
              id: branch.id,
              disabled: this.data.metadata.branchData.main===branch.id
            }

            arr.push(obj);
          }
          this.remBranches = arr;
        }

        if(this.lastBranch) this.data.metadata.branchData.allowed = this.data.metadata.branchData.allowed.filter(b => {return b!==this.lastBranch})
        if(this.data.metadata.branchData.main){
          if(this.data.metadata.branchData.allowed.indexOf(this.data.metadata.branchData.main)<0) this.data.metadata.branchData.allowed.push(this.data.metadata.branchData.main);
        }
        this.lastBranch = this.data.metadata.branchData.main;
      }
    }
  }
</script>
